var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prk-shadow br-15"},[_c('prk-list-filter',{attrs:{"filters-type":"standard"},on:{"update:filters":_vm.updateFilters}}),_vm._v(" "),_c('dictionaries-standard-table',{attrs:{"filters":_vm.filters}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }